import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GS1CardComponent, GS1CardConfig } from '@gs1france/gs1-components-library';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TagsService } from '../../core/services/tags.service';

@Component({
  selector: 'app-home-our-services',
  imports: [GS1CardComponent, TranslatePipe],
  templateUrl: './home-our-services.component.html',
  styleUrl: './home-our-services.component.scss'
})
export class HomeOurServicesComponent {
  router = inject(Router);
  translateService = inject(TranslateService);
  private tagsService = inject(TagsService);

  private readonly blockNames: Record<string, string> = {
    standards: 'Bloc standards',
    formations: 'Bloc formation',
    services: 'Bloc offre conseil',
    colab: 'Bloc collaboration',
    'qr-codes': 'Bloc QRCAG',
    partners: 'Bloc GS1 partenaire'
  };

  cardsList: (GS1CardConfig & { image: string; url?: string; route?: string })[] = [
    {
      name: 'standards',
      title: this.translateService.instant('home.our-services.standards.title'),
      text: this.translateService.instant('home.our-services.standards.text'),
      url: 'https://www.gs1.fr/collaborer-gs1-france/nos-standards',
      image: 'assets/svg/standards.svg'
    },
    {
      name: 'formations',
      title: this.translateService.instant('home.our-services.formations.title'),
      text: this.translateService.instant('home.our-services.formations.text'),
      url: 'https://www.gs1.fr/formations-conseil-qualite/formez-vous-aux-standards-gs1',
      image: 'assets/svg/formations.svg'
    },
    {
      name: 'services',
      title: this.translateService.instant('home.our-services.services.title'),
      text: this.translateService.instant('home.our-services.services.text'),
      url: 'https://www.gs1.fr/formation-conseil',
      image: 'assets/svg/services.svg'
    },
    {
      name: 'colab',
      title: this.translateService.instant('home.our-services.colab.title'),
      text: this.translateService.instant('home.our-services.colab.text'),
      route: '/collaboration',
      image: 'assets/svg/colab.svg'
    },
    {
      name: 'qr-codes',
      title: this.translateService.instant('home.our-services.qr-codes.title'),
      text: this.translateService.instant('home.our-services.qr-codes.text'),
      url: 'https://www.gs1.fr/qr-code-augmente-gs1',
      image: 'assets/svg/qr-codes.svg'
    },
    {
      name: 'partners',
      title: this.translateService.instant('home.our-services.partners.title'),
      text: this.translateService.instant('home.our-services.partners.text'),
      url: 'https://mespartenaires.gs1.fr/fr/',
      image: 'assets/svg/partners.svg'
    }
  ];

  navigateTo(url: string, route?: string, cardName?: string) {
    const block = cardName ? this.blockNames[cardName] : undefined;
    if (block) this.tagsService.sendEvent('clic_accompagnement', { bloc: block });
    if (url) window.open(url, '_blank', 'noopener');
    else if (route) this.router.navigate([route]);
  }
}
